import ReCAPTCHA from 'react-google-recaptcha';

export const verifyRecaptcha = async (recaptcha: ReCAPTCHA) => {
    // console.log('init verifyRecaptcha');
    const token = await recaptcha.executeAsync();
    // console.log('result verifyRecaptcha', token);
    if (token && typeof token == 'string') {
        return token;
    } else {
        return null;
    }
};
